import Datetime from 'utils/datetime/datetime'

// The day-ahead spot price for the next day is settled once the auction closes at 12:00 UTC.
const SPOT_PRICE_SETTLEMENT_HOUR_UTC = 12

export function isSpotPriceSettledForDate(chosenDate: ISODateTime, now: ISODateTime): boolean {
  const startOfToday = Datetime.getStartOfDay(now)
  const { startTime: startOfTomorrow } = Datetime.getDayAfterDate(now)
  const startOfChosenDate = Datetime.getStartOfDay(chosenDate)

  if (Datetime.isAfter(startOfChosenDate, startOfTomorrow)) {
    return false
  }

  if (Datetime.isBeforeOrEqual(startOfChosenDate, startOfToday)) {
    return true
  }

  return new Date(now).getUTCHours() >= SPOT_PRICE_SETTLEMENT_HOUR_UTC
}
